import AgentDistrictRepository from "../api/agentDistrict";

class AgentDistrictUseCase {
    constructor() {
        /** @type {AgentDistrictRepository} */
        this.api = new AgentDistrictRepository();
    }
    
    async getAllDistrictBySearch(input) {
        const {data, err} = await this.api.findDistrict(input)
        if (data.data) {
            return {data: data.data, err: null}
        }
        return {data: null, err: err}
    }
}

export default new AgentDistrictUseCase()
